/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  decorator.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:25
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { toType } from "./util"

/**
 * 确认框
 * @param {String} title - 标题
 * @param {String} concent - 内容
 * @param {String} confirmButtonText - 确认按钮名称
 * @returns
 */
 export const confirm = (title, concent, confirmButtonText = '确定') => {
  return (target, name, descriptor) => {
    const method = descriptor.value
    descriptor.value = function (...args) {
      const isUseFunction = (key) => toType(key, 'Function') ? key(...args) : key
      const _this = this._isVue ? this : target
      const _title = isUseFunction(title)
      const _concent = isUseFunction(concent)

      return this.$dialog.confirm({
        title: _title,
        message: _concent,
        confirmButtonText
      }).then(() => {
        method.call(_this, ...args)
      })
    }
  }
}
